var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_32775",
    "data-name": "Group 32775",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.094,
    height: 22.272,
    viewBox: "0 0 21.094 22.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_43690",
    "data-name": "Path 43690",
    d: "M16.5,16.156c-2.174-3.2-5.077-4.9-6.6-3.856a1.754,1.754,0,0,0-.43.432c0,.012-3.519,7.135-3.519,7.135L3.992,21.2a2.775,2.775,0,0,0-.737,3.856l.088.13a2.78,2.78,0,0,0,3.839.737l3.156,4.649a1.791,1.791,0,0,0,2.456.472,1.663,1.663,0,0,0,.737-1.13,1.758,1.758,0,0,0-.273-1.326l-2.78-4.1s6.572-.523,6.6-.533a1.574,1.574,0,0,0,.572-.246c.781-.53,1.061-1.643.791-3.134A12.018,12.018,0,0,0,16.5,16.156ZM4.059,24.7l-.088-.13a1.913,1.913,0,0,1,.511-2.66l1.7-1.154,2.24,3.3-1.7,1.154A1.916,1.916,0,0,1,4.059,24.7Zm8.493,4.369a.909.909,0,0,1-1.508,1.014L7.9,25.45l1.265-.86.334-.027ZM9.231,23.721l-2.441-3.6,2.328-4.747a11.819,11.819,0,0,0,1.943,4.472A11.857,11.857,0,0,0,14.5,23.306Zm7.245-.572c-1.174-.076-3.085-1.4-4.7-3.785S9.629,14.722,9.99,13.6a1.046,1.046,0,0,1,.982-.737c1.164,0,3.146,1.331,4.811,3.785a10.478,10.478,0,0,1,1.808,4.087C17.957,23.149,16.476,23.149,16.476,23.149Z",
    transform: "translate(-2.776 -9.073)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43691",
    "data-name": "Path 43691",
    d: "M40.227,29.177a2.306,2.306,0,0,0-1.749.361.432.432,0,1,0,.491.71,1.474,1.474,0,0,1,1.655,2.439.43.43,0,0,0,.246.783.42.42,0,0,0,.246-.074,2.331,2.331,0,0,0-.872-4.219Z",
    transform: "translate(-29.57 -22.003)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43692",
    "data-name": "Path 43692",
    d: "M59.646,4.194h.042a.43.43,0,0,0,.427-.386L60.447.586A.43.43,0,1,0,59.592.5l-.329,3.225A.43.43,0,0,0,59.646,4.194Z",
    transform: "translate(-45.388 -0.1)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43693",
    "data-name": "Path 43693",
    d: "M71.828,13.476a.432.432,0,0,0-.6-.123l-2.994,1.965a.43.43,0,0,0,.246.788.437.437,0,0,0,.246-.069l2.994-1.965A.43.43,0,0,0,71.828,13.476Z",
    transform: "translate(-52.014 -10.045)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43694",
    "data-name": "Path 43694",
    d: "M74.926,33.485l-3.483-.626a.43.43,0,0,0-.152.847l3.48.626h.076a.43.43,0,0,0,.076-.855Z",
    transform: "translate(-54.197 -24.808)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.4cba828d65f61b613afab2a7709c7baa.svg";
export { ForwardRef as ReactComponent };